import { useEffect } from 'react';

export default function useOutsideClick(ref, callback) {
  useEffect(() => {
    const clickOutsideHandler = (event) => {
      event.stopPropagation();
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener('click', clickOutsideHandler, false);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', clickOutsideHandler, false);
    };
  }, [ref, callback]);
}
